module.exports = __webpack_public_path__ + "static/img/illust_6_mk.2c626e27.svg";